export default Object.freeze({
    image: 'image',
    gallery: 'gallery',
    video: 'video',
    audio: 'audio',
    file: 'file',
})
